import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';

export interface Option {
  name: string;
  value: string;
}
@Component({
  selector: 'app-select-dropdown',
  standalone: true,
  imports: [
  CommonModule,
FormsModule],
  templateUrl: './select-dropdown.component.html',
  styleUrl: './select-dropdown.component.scss'
})
export class SelectDropdownComponent {
  @Input() options: Option[] = [];
  @Input() selectedOption: string | null = null;
  @Input() isOpen: boolean = false;
  @Input() placeHolder: string | null = null;
  @Input() permanentLabel: string | null = null;
  @Output() selectionChange = new EventEmitter<Option>();
  categorySelected: boolean = false

  constructor(private elementRef: ElementRef) {}

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: Option) {
    this.selectedOption = option.name;
    this.selectionChange.emit(option);
    this.isOpen = false;
    this.categorySelected = true;
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
  // onClick(event: MouseEvent) {
  //   const target = event.target as HTMLElement;
  //   const dropdown = document.querySelector('.dropdown') as HTMLElement;
  //   if (this.isOpen && dropdown && !dropdown.contains(target)) {
  //     this.isOpen = false;
  //   }
  // }
}
